import { render, staticRenderFns } from "./ChartChangeIndicator.vue?vue&type=template&id=8b557ba0"
import script from "./ChartChangeIndicator.vue?vue&type=script&lang=js"
export * from "./ChartChangeIndicator.vue?vue&type=script&lang=js"
import style0 from "./ChartChangeIndicator.vue?vue&type=style&index=0&id=8b557ba0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports